import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';
import style from './CountdownText.css';

class CountdownText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      duration: props.duration,
    };
  }

  componentDidMount() {
    this.startCountdown();
  }

  formatDuration = duration => {
    const sec = duration % 60;
    const seconds = sec < 10 ? `0${sec}` : sec;
    const minutes = Math.floor(duration / 60);
    return `${minutes}:${seconds}`;
  };

  startCountdown() {
    const { clearInterval, setInterval } = this.props;
    setInterval(() => {
      const { duration } = this.state;
      if (duration <= 0) {
        clearInterval();
      } else {
        this.setState({ duration: duration - 1 });
      }
    }, 1000);
  }

  render() {
    const { prefix } = this.props;
    const { duration } = this.state;
    const timeLeft = this.formatDuration(duration);
    return (
      <div className={style.countdownTime}>
        {prefix}
        {timeLeft}
      </div>
    );
  }
}

CountdownText.defaultProps = {
  prefix: null,
};

CountdownText.propTypes = {
  duration: PropTypes.number.isRequired,
  setInterval: PropTypes.func.isRequired,
  clearInterval: PropTypes.func.isRequired,
  prefix: PropTypes.string,
};

const TimeoutCountdownText = ReactTimeout(CountdownText);

export default TimeoutCountdownText;
